import { Color, Markdown, Table, Typography } from '@elearning-platform/ui';
import { styled } from 'styled-components';

export const Container = styled.div`
  background-color: ${Color.Gray100};
  padding: 32px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-bottom: 15px;
  margin-bottom: 25px;
  border-bottom: 2px solid ${Color.Brand300};
`;

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
`;

export const StyledDescription = styled(Markdown)`
  flex-direction: column;
`;

export const StyledTable = styled(Table)`
  width: 100%;
  min-width: 569px;
`;

export const TableWrapper = styled.div`
  overflow-x: auto;
`;

export const StyledTypography = styled(Typography)`
  margin-top: 40px;
`;
